export default __webpack_public_path__ + "static/6-8c94885eded67e38926968c62da25ebf.jpg";